var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('Editor',{staticClass:"instructions-editor",model:{value:(_vm.form.instruction),callback:function ($$v) {_vm.$set(_vm.form, "instruction", $$v)},expression:"form.instruction"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }